module.exports = __webpack_public_path__ + "img/business-plan.7d4fad0f.svg";